import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { popupActions } from '../../store/popupStore';
import { searchInstances } from '../../store/relationsSearchStore';
import { windowActions } from '../../store/windowStore';
import { withLocalize, Translate } from "react-localize-redux";
import { withRouter } from 'react-router';
import classnames from 'classnames'
import Message from '../common/message';
import NavigationRow from "../layoutItems/navigationRow";
import RelationsSearchInstance, { checkTypes } from "../../components/search/relations/relationsSearchInstance";
import SearchTip from '../common/searchTip';
import TabLink from '../search/tabLink';
import FormMenuControl from '../common/formMenuControl'
import MspIconTab1 from '../../img/icons/ess/Msp';
import { hasPermission } from "../../store/apiWrapper";

class CustomizableMspSearch extends React.Component {
    prefix = "/search/customizable-msp";

    state = {
        entityId: undefined,
        error: false,
        selected: "customizableMsp"
    }

    onEntityCheck(checkedEntities) {
        this.setState({ entityId: checkedEntities.length > 0 ? checkedEntities[0] : undefined }, () => this.setError());
    }

    render() {
        const labelSuffix = hasPermission(null, 'CustomizableCompanyInDifficulty') ? 'Diff' : '';
        return (
            <>
                <div className="content-root content-root-wide">
                    <div className="columns is-desktop">
                        <div className="column is-4-desktop tabs tabs-form-menu" style={{ fontSize: "1em" }}>
                            <FormMenuControl>
                                <ul>
                                    <TabLink type='customizableMsp' selected={this.state.selected} onSelect={this.selectSearch} icon={<MspIconTab1 className="tabs-icon" />}
                                        titleKey={`CustomizableMsp.Tab1.Name${labelSuffix}`} descriptionKey={`CustomizableMsp.Tab1.Description${labelSuffix}`} hr={true} />
                                </ul>
                            </FormMenuControl>
                        </div>
                        <div className='column'>
                            <div className='card-body'>
                                <SearchTip windowId='tips_customizable_msp' getSearchTipsModel={this.getSearchTipsModel} style={{ marginTop: '-2em' }} />
                                {this.state.error &&
                                    <Message type="warning" message={this.props.translate('Search.Relations.Error.IdenticalEntities')} options={{ renderInnerHtml: true }} shadowed style={{ marginBottom: "1em" }} />}
                                <div>
                                    <div className="search-wrap">
                                        <div className={`search-content`} style={{ margin: '0em', padding: '0em' }}>
                                            <div className="search-container">
                                                <RelationsSearchInstance
                                                    instanceKey={searchInstances.msp}
                                                    ordinal={1}
                                                    checkType={checkTypes.single}
                                                    onEntityCheck={(v) => this.onEntityCheck(v)}
                                                    scroller={this.props.scroller}
                                                    showSearchButton
                                                    disableSubjectLabel
                                                    marketAttribute={3}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <NavigationRow justify='flex-end'>
                    <button
                        className={classnames('bb-button gradient-1', { 'is-cube': localStorage.locales_button_style === 'square' })}
                        type="button"
                        disabled={!this.canContinue()}
                        onClick={() => this.onContinue()}>
                        <Translate id="CustomizableMsp.Button.ShowReport"></Translate>
                    </button>
                </NavigationRow>
            </>
        )
    }

    selectSearch = (selected) => {
        if (selected !== this.state.selected) {
            this.setState({ selected: selected });
            this.props.closeAll();
        }
    }

    getSearchTipsModel = () => {
        return { title: `${this.props.translate('SearchTips.CustomizableMsp.Header')}`, bodyHtml: this.props.translate('SearchTips.CustomizableMsp.Body') };
    }

    canContinue = () => {
        const result = !isNullOrUndefined(this.state.entityId);
        return result;
    }

    setError = () => {
        this.setState({ error: this.state.error && this.canContinue() && this.state.entityId === this.state.secondEntityId })
    }

    onContinue = () => {
        this.setState({ error: this.state.entityId === this.state.secondEntityId }, () => {
            if (!this.state.error) {
                this.props.history.push({
                    pathname: `${this.prefix}/report/${this.state.entityId}`,
                    state: { entityId: this.state.entityId }
                });
            }
        });
    }
}

export default withRouter(withLocalize(connect(null,
    dispatch => bindActionCreators({ ...windowActions, ...popupActions }, dispatch))(CustomizableMspSearch)));